import { createStateSelectorHook } from 'src/lib/sweetState';

import { ReadonlyDocumentScoresStore } from '../store';

const useStoreState = createStateSelectorHook(ReadonlyDocumentScoresStore, [
  'activeVariationInstanceId',
  'detailsPanelVisibleForInstanceId',
]);

/** The item whose details panel is open wins over the hovered one: one item is highlighted at a time. */
export const useActiveVariationInstanceId = () => {
  const { activeVariationInstanceId, detailsPanelVisibleForInstanceId } = useStoreState();
  return detailsPanelVisibleForInstanceId ?? activeVariationInstanceId;
};
